React = require 'react/addons'
Router = require 'react-router'
navigationActions = require '../../actions/navigation'
MediaQuery = require '../../mixins/media-query'
Link = Router.Link
throttle = require 'lodash.throttle'
classSet = React.addons.classSet

previouslyMuted = false

module.exports = React.createClass
  displayName: 'VideoPlayer'

  mixins: [MediaQuery]

  propTypes:
    video: React.PropTypes.shape
      webm: React.PropTypes.string
      mp4: React.PropTypes.string
      ogv: React.PropTypes.string
    initialPlaylist: React.PropTypes.shape
      videos: React.PropTypes.array
      index: React.PropTypes.number
    onNext: React.PropTypes.func
    onEnded: React.PropTypes.func
    onPlayingNext: React.PropTypes.func
    onPrev: React.PropTypes.func
    onClose: React.PropTypes.func

  getInitialState: ->
    return {
      playlistVideos: @props.initialPlaylist?.videos
      playlistInitialIndex: @props.initialPlaylist?.index
      playlistIndex: @props.initialPlaylist?.index
      displayEmbed: false
      playing: false
      loading: false
      hideEmbed: false
      previouslyMuted: previouslyMuted
      muted: previouslyMuted
      windowWidth: window.innerWidth
      windowHeight: window.innerHeight
      needsResize: true
      disablePoster: false
    }

  onClose: (event) ->
    event.preventDefault()
    if @props.onClose then @props.onClose()

  onNext: (event) ->
    event.preventDefault()
    if @props.onNext then @props.onNext()

  onPrev: (event) ->
    event.preventDefault()
    if @props.onPrev then @props.onPrev()

  componentWillMount: ->
    if @props.video.dark
      navigationActions.darkMode()
    else
      navigationActions.lightMode()

  onEnded: ->
    if @props.onEnded then @props.onEnded()

    if @state.playlistVideos
      nextIndex = @state.playlistIndex + 1
      if nextIndex >= @state.playlistVideos.length then nextIndex = 0

      @setState { playlistIndex: nextIndex, disablePoster: true }, =>
        if @props.onPlayingNext then @props.onPlayingNext nextIndex
        @playNextVideo @state.playlistVideos[nextIndex]

  playNextVideo: (videoDefinition) ->
    video = @chooseVideoFormat videoDefinition
    vid = @refs.video.getDOMNode()

    vid.src = video
    vid.load()
    vid.play()

  onPlaying: ->
    @setState { playing: true, loading: false }

  onStop: ->
    vid = @refs.video.getDOMNode()

    newState = { playing: false, loading: false }

    if not(vid.ended)
      newState.playlistIndex = @state.playlistInitialIndex
      newState.disablePoster = false

      video = @chooseVideoFormat @props.video
      if @props.onPlayingNext then @props.onPlayingNext @state.playlistInitialIndex
      vid.src = video

    @setState newState

  onPlay: ->
    @setState { playing: false, loading: true }

  onMute: (e) ->
    e.preventDefault()

    vid = @refs.video.getDOMNode()
    vid.muted = !vid.muted

    return

  onVolumeChange: ->
    vid = @refs.video.getDOMNode()
    previouslyMuted = vid.muted
    @setState { muted: vid.muted }

    return

  playVideo: ->
    vid = @refs.video.getDOMNode()
    return unless vid.paused

    vid.load()
    vid.play()

    @startHideTimer()

    isiPad = navigator.userAgent.match(/iPad/i) != null
    vid.webkitEnterFullscreen() if vid.webkitSupportsFullscreen and isiPad

  hideEmbed: ->
    if @props.embed then navigationActions.hideLogo()
    @setState { hideEmbed: true }

  showEmbed: ->
    if @props.embed then navigationActions.showLogo()
    @setState { hideEmbed: false }

  startHideTimer: ->
    return unless @props.embed

    @killHideTimer()
    @timeout = setTimeout @hideEmbed, 3000

  killHideTimer: ->
    if @timeout
      clearTimeout @timeout
      @timeout = null

  onMouseMove: ->
    if @state.playing then @showEmbed()
    if @timeout then @startHideTimer()

  handleResize: ->
    @setState
      windowWidth: window.innerWidth
      windowHeight: window.innerHeight
      needsResize: false

  componentDidMount: ->
    vid = @refs.video.getDOMNode()
    vid.addEventListener 'playing', @onPlaying
    vid.addEventListener 'pause', @onStop
    vid.addEventListener 'play', @onPlay
    vid.addEventListener 'ended', @onEnded
    vid.addEventListener 'volumechange', @onVolumeChange

    window.addEventListener 'resize', @handleResize

    @playVideo() unless @state.isMobile

  componentWillUnmount: ->
    vid = @refs.video.getDOMNode()
    vid.removeEventListener 'playing', @onPlaying
    vid.removeEventListener 'pause', @onStop
    vid.removeEventListener 'play', @onPlay
    vid.removeEventListener 'ended', @onEnded
    vid.removeEventListener 'volumechange', @onVolumeChange

    window.removeEventListener 'resize', @handleResize

    @killHideTimer()
    navigationActions.showLogo()

  onClick: ->
    @playVideo()

  onEmbed: ->
    if @state.displayEmbed then @setState { displayEmbed: false }
    else @setState { displayEmbed: true }

  componentDidUpdate: (prevProps, prevState) ->
    if @state.needsResize then @handleResize()
    if prevState.isMobile isnt @state.isMobile and not(@state.isMobile)
      @playVideo()

  chooseVideoFormat: (videoDefinition) ->
    prefix = CDN_URL
    videoSource = null

    if Modernizr.video.h264 isnt '' then videoSource = videoDefinition.mp4
    else if Modernizr.video.webm isnt '' then videoSource = videoDefinition.webm

    "#{prefix}#{videoSource}"

  render: ->
    prefix = CDN_URL

    thumbImage = if @state.disablePoster then '' else "#{prefix}#{@props.video.thumb}"
    posterStyle = { display: (if @state.disablePoster then 'none' else 'block'), backgroundImage: "url('#{thumbImage}')" }
    playStyle = { display: 'block' }
    hittestStyle = { display: 'block' }
    loadingStyle = { display: 'none' }
    videoStyle = { display: 'none' }
    mutedClassName = classSet
      'video-mute': true
      'is-muted': @state.muted is true
      'hide-video-mute': @state.hideEmbed
      'show-video-mute': not(@state.hideEmbed)
    embedClassName = classSet
      'video-embed': true
      'hide-video-embed': @state.hideEmbed
      'show-video-embed': not(@state.hideEmbed)
    videoLoadingClassName = classSet
      'video-loading': true
      'force-light-load': @props.video.lightLoad ? false
    videoWrapperClassName = classSet
      'video-player-wrap': true
      'has-close-btn': !!@props.onClose
      'has-embed-btn': !!@props.embed

    if not(@state.isMobile)
      videoStyle.display = 'block'
      hittestStyle.display = 'none'
      posterStyle.display = 'none'
      loadingStyle.display = 'none'
      playStyle.display = 'none'

    if @state.loading
      loadingStyle.display = 'block'

    if @state.playing
      videoStyle.display = 'block'
      hittestStyle.display = 'none'
      posterStyle.display = 'none'
      loadingStyle.display = 'none'
      playStyle.display = 'none'

    vh = @state.windowHeight
    vw = @state.windowWidth

    if vw / vh <= 16 / 9 then vw = vh * 16 / 9
    else vh = vw * 9 / 16

    videoStyle.top = Math.ceil((@state.windowHeight - vh) / 2)
    videoStyle.left = Math.ceil((@state.windowWidth - vw) / 2)

    imgFormat = if Modernizr.svg then '.svg' else '.png'

    videoSource = @chooseVideoFormat @props.video

    vidDefinition =
      ref: 'video'
      src: videoSource
      poster: thumbImage
      style: videoStyle
      onMouseMove: @onMouseMove

    unless @state.playlistVideos
      vidDefinition.loop = 'loop'

    if @state.previouslyMuted
      vidDefinition.muted = 'muted'

    vidElement = React.createElement 'video', vidDefinition

    React.createElement("div", {"className": (videoWrapperClassName)},
      (vidElement),
      React.createElement("div", {"ref": 'poster', "className": 'video-poster', "style": (posterStyle), "onClick": (@onClick)}),
      React.createElement("div", {"ref": 'play', "className": 'video-play', "style": (playStyle), "onClick": (@onClick)}),
      React.createElement("div", {"ref": 'loading', "className": (videoLoadingClassName), "style": (loadingStyle)}, "Loading"),
      React.createElement("div", {"ref": 'hittest', "className": 'video-hittest', "style": (hittestStyle), "onClick": (@onClick)}),

      ( React.createElement("a", {"href": '#', "onClick": (@onEmbed), "className": (embedClassName)}, React.createElement("img", {"src": ("#{prefix}/img/embed-video#{imgFormat}"), "alt": 'embed video'})) if @props.embed ),
      ( React.createElement("div", {"className": 'video-embed-backing', "onClick": (@onEmbed)}) if @props.embed and @state.displayEmbed ),
      ( React.createElement("div", {"className": 'video-embed-code', "ref": 'videoEmbed'}, React.createElement("textarea", {"ref": 'videoEmbedCode', "defaultValue": (@props.embed)})) if @props.embed and @state.displayEmbed ),
      ( React.createElement("a", {"href": '#', "onClick": (@onMute), "className": (mutedClassName)}, React.createElement("span", null, "mute video")) ),
      ( React.createElement("a", {"href": '#', "onClick": (@onClose), "className": 'video-close'}, React.createElement("span", null, "close video")) if @props.onClose ),
      ( React.createElement("a", {"href": '#', "onClick": (@onNext), "className": 'video-next'}, React.createElement("span", null, "play next video")) if @props.onNext ),
      ( React.createElement("a", {"href": '#', "onClick": (@onPrev), "className": 'video-prev'}, React.createElement("span", null, "play previous video")) if @props.onPrev )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/shared/video-player.cjsx
 **/